import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  filteredProducts: [],
  displayedProducts: [],
  updateCount: {},
  incentiveTypes: ['%', 'INR'],
  updatedProductsData: {
    productName: '',
    hsnCode: '',
    mrp: '',
    volume: '',
    unit: '',
    productCount: '',
    sellPrice: '',
    rewardPoints: '',
    staffIncentive: '',
    incentiveType: '%',
  },
  pagination: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 1,
  },
  filters: {
    search: '',
  },
  GST: 0,
};

const productSlice = createSlice({
  name: 'Products',
  initialState,
  reducers: {
    setAllProductData: (state, action) => {
      state.products = action.payload;
      applyFilters(state);
    },

    updateProductInState: (state, action) => {
      const updatedProduct = action.payload;
      state.products = state.products.map(product =>
        product._id === updatedProduct._id ? updatedProduct : product
      );

      // Instead of calling applyFilters, just update the filteredProducts and displayedProducts
      state.filteredProducts = state.filteredProducts.map(product =>
        product._id === updatedProduct._id ? updatedProduct : product
      );

      // Update the displayed products without resetting the page
      updateDisplayedProducts(state);
    },

    removeProductsFromState: (state, action) => {
      const idsToRemove = action.payload;
      state.products = state.products.filter(
        product => !idsToRemove.includes(product._id)
      );
      state.filteredProducts = state.filteredProducts.filter(
        product => !idsToRemove.includes(product._id)
      );
      updateDisplayedProducts(state);
    },

    setUpdateCount: (state, action) => {
      const { productId, count } = action.payload;
      state.updateCount[productId] = count;
    },

    clearUpdateCount: (state, action) => {
      delete state.updateCount[action.payload];
    },

    updateProductsData: (state, action) => {
      state.updatedProductsData = action.payload;
    },

    updateSingleProductField: (state, action) => {
      const { name, value } = action.payload;
      state.updatedProductsData[name] = value;
    },

    clearUpdatedProductData: (state) => {
      state.updatedProductsData = initialState.updatedProductsData;
    },

    setSearchFilter: (state, action) => {
      state.filters.search = action.payload ?? '';
      applyFilters(state);
    },


    // In your reducers, modify setItemsPerPage to reset to page 1
    setItemsPerPage: (state, action) => {
      state.pagination.itemsPerPage = action.payload;
      state.pagination.currentPage = 1; // Reset to first page
      applyFilters(state); // This will recalculate everything
    },

    setCurrentPage: (state, action) => {
      console.log(state, 'state current page ')
      console.log(action, 'action current page')
      state.pagination.currentPage = action.payload;
      updateDisplayedProducts(state);
    },
    clearAllUpdateCounts: (state) => {
      state.updateCount = {};
    },

    resetFilters: (state) => {
      console.log(state, 'reset filters')
      state.filters.search = '';
      applyFilters(state);
    }
  },
});

function applyFilters(state) {
  const { search, minMrp, maxMrp } = state.filters;
  const { products } = state;

  let newFilteredProducts = [...products];

  // Apply search filter
  const cleanSearch = (search || '').trim();
  if (cleanSearch) {
    const lowerSearch = cleanSearch.toLowerCase().replace(/\s/g, '');
    newFilteredProducts = newFilteredProducts.filter(item => {
      const lowerProductName = item?.productName?.toLowerCase().replace(/\s/g, '');
      if (!lowerProductName) {
        return false;
      }
      
      let nameIndex = 0;
      let searchIndex = 0;
      while (nameIndex < lowerProductName.length && searchIndex < lowerSearch.length) {
        if (lowerProductName[nameIndex] === lowerSearch[searchIndex]) {
          searchIndex++;
        }
        nameIndex++;
      }
      return searchIndex === lowerSearch.length;
    });
  }

  // Apply minMrp filter
  if (minMrp !== '') {
    const min = parseFloat(minMrp);
    if (!isNaN(min)) {
      newFilteredProducts = newFilteredProducts.filter(item => {
        const mrp = parseFloat(item?.mrp);
        return !isNaN(mrp) && mrp >= min;
      });
    }
  }

  // Apply maxMrp filter
  if (maxMrp !== '') {
    const max = parseFloat(maxMrp);
    if (!isNaN(max)) {
      newFilteredProducts = newFilteredProducts.filter(item => {
        const mrp = parseFloat(item?.mrp);
        return !isNaN(mrp) && mrp <= max;
      });
    }
  }

  state.filteredProducts = newFilteredProducts;
  // Update pagination info
  state.pagination.totalItems = state.filteredProducts.length;
  state.pagination.totalPages = Math.ceil(state.filteredProducts.length / state.pagination.itemsPerPage) || 1;
  state.pagination.currentPage = 1;

  updateDisplayedProducts(state);
}


function updateDisplayedProducts(state) {
  const { currentPage, itemsPerPage } = state.pagination;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  state.displayedProducts = state.filteredProducts.slice(startIndex, endIndex);
}
export const {
  setAllProductData,
  updateProductInState,
  removeProductsFromState,
  setUpdateCount,
  clearUpdateCount,
  updateProductsData,
  updateSingleProductField,
  clearUpdatedProductData,
  setSearchFilter,
  setMinMrpFilter,
  setMaxMrpFilter,
  setItemsPerPage,
  setCurrentPage,
  resetFilters,
  clearAllUpdateCounts
} = productSlice.actions;

export default productSlice.reducer;